<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-6">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ThirdPartyAPI',
    data() {
        return {
            thirdPartyAPIs: [
                {
                    'flights': [
                        {
                            id: 1,
                            slug: 'flight_api',
                            name: 'Flightapi.io',
                            description: 'Description for API One'
                        },
                    ]   
                }
            ]
        };
    }            
}
</script>

<style lang="scss" scoped>

</style>